/**
 * Created by mukund on 8/24/17.
 */

angular.module('mediacloudApp')
    .directive('mediaInbox', ['AssetService', 'SearchService', 'CollectionService', function(AssetService, SearchService, CollectionService){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/media-inbox/media-inbox.html',
            scope: {
                openContent: '&',
                parent: '=',
                submissions: '=',
                collectionTree: '='
            },
            link: function(scope, element, attrs){

                scope.activeLink = 'mediainbox';

                scope.collapsedSections = {dropbox: false, assignments: false};

                scope.assetsPerPage = 5;

                scope.pagination = {
                    current: 1
                };

                // Options for sorting assets
                scope.sorts = [
                    {id: 'publishedDate', name: 'Date'},
                    {id: 'contributor', name: 'Contributor'},
                    {id: 'title', name: 'Title'}
                ];

                // We sort by 'Date' by default
                scope.activeSort = scope.sorts[0];

                scope.search = {query: "", activateSearch: false};

                scope.showSearchResults = false;

                scope.allAssets = {selected: false, selectCount: 0};

                scope.$watch('parent', function() {
                    if(scope.parent && scope.parent.acl.indexOf('W') !== -1){
                        scope.getMediaInboxAssets();
                    }
                });

                scope.$watch('submissions.new', function() {
                    if(scope.parent && scope.parent.acl.indexOf('W') !== -1 && scope.submissions && scope.submissions.new != null){
                        scope.getMediaInboxAssets();
                    }
                });

                scope.getDropboxAssets = function(page){
                    AssetService.GetAssets.get({cid: scope.parent.dropboxCid, sortOn: scope.activeSort.id, limit: scope.assetsPerPage, offset: (page - 1) * scope.assetsPerPage}, function (result) {
                        scope.parent.dropboxAssets = result.contents;
                        scope.parent.totalDropboxAssets = result.totalContents;
                        selectContentsIfRequired();
                    });
                };

                scope.getZoomAssets = function(page){
                    AssetService.GetAssets.get({cid: scope.parent.zoomCid, sortOn: scope.activeSort.id, limit: scope.assetsPerPage, offset: (page - 1) * scope.assetsPerPage}, function (result) {
                        scope.parent.zoomAssets = result.contents;
                        scope.parent.totalZoomAssets = result.totalContents;
                        selectContentsIfRequired();
                    });
                };

                scope.getAssignmentAssets = function(page){
                    AssetService.GetAssets.get({cid: scope.parent.assignmentCid, sortOn: scope.activeSort.id, limit: scope.assetsPerPage, offset: (page - 1) * scope.assetsPerPage}, function (result) {
                        scope.parent.assignmentAssets = result.contents;
                        scope.parent.totalAssignmentAssets = result.totalContents;
                        selectContentsIfRequired();
                    });
                };

                scope.getMediaInboxAssets = function(){
                    if(scope.parent.dropboxCid){
                        scope.getDropboxAssets(scope.pagination.current);
                    }
                    if(scope.parent.assignmentCid){
                        scope.getAssignmentAssets(scope.pagination.current);
                    }
                    if(scope.parent.zoomCid){
                        scope.getZoomAssets(scope.pagination.current);
                    }
                };

                scope.sortContent = function(sort){
                    scope.pagination.current = 1;
                    scope.activeSort = sort;
                    scope.getMediaInboxAssets();
                };

                scope.toggleSearch = function () {
                    scope.search.activateSearch = !scope.search.activateSearch;
                    if (!scope.search.activateSearch) {
                        scope.showSearchResults = false;
                        scope.search.query = "";
                    }
                };

                var findContent = function () {
                    var query = scope.search.query;
                    if(query) {
                        scope.searchResults = {
                            searchTerm: query,
                            dropbox: {
                                hits: [],
                                totalHits: 0
                            },
                            assignment: {
                                hits: [],
                                totalHits: 0
                            },
                            zoom: {
                                hits: [],
                                totalHits: 0
                            },
                            totalHits: 0
                        };
                        if (scope.parent.dropboxCid) {
                            SearchService.SearchAssets.get({
                                query: query,
                                sitewide: false,
                                cid: scope.parent.dropboxCid,
                                limit: 200,
                                offset: 0
                            }, function (contentList) {
                                scope.searchResults.dropbox = {
                                    hits: contentList.contents,
                                    totalHits: contentList.contents.length
                                };
                                scope.searchResults.totalHits += contentList.contents.length;
                                selectContentsIfRequired();
                                scope.showSearchResults = true;
                            });
                        }
                        if (scope.parent.zoomCid) {
                            SearchService.SearchAssets.get({
                                query: query,
                                sitewide: false,
                                cid: scope.parent.zoomCid,
                                limit: 200,
                                offset: 0
                            }, function (contentList) {
                                scope.searchResults.zoom = {
                                    hits: contentList.contents,
                                    totalHits: contentList.contents.length
                                };
                                scope.searchResults.totalHits += contentList.contents.length;
                                selectContentsIfRequired();
                                scope.showSearchResults = true;
                            });
                        }
                        if (scope.parent.assignmentCid) {
                            SearchService.SearchAssets.get({
                                query: query,
                                sitewide: false,
                                cid: scope.parent.assignmentCid,
                                limit: 200,
                                offset: 0
                            }, function (contentList) {
                                scope.searchResults.assignment = {
                                    hits: contentList.contents,
                                    totalHits: contentList.contents.length
                                };
                                scope.searchResults.totalHits += contentList.contents.length;
                                selectContentsIfRequired();
                                scope.showSearchResults = true;
                            });
                        }
                    } else {
                        scope.showSearchResults = false;
                    }
                };

                scope.checkForEnterKey = function (event, action, sort) {
                    if (event.keyCode === 13) {
                        switch(action){
                            case "search":
                                findContent();
                                break;
                            case "publish":
                                scope.createPublishRequest();
                                break;
                            case "markAsNew":
                                scope.markAsNew();
                                break;
                            case "delete":
                                scope.createDeleteRequest();
                                break;
                            case "sort":
                                scope.sortContent(sort);
                        }
                    }
                };

                // This is called whenever the 'Select All Assets' checkbox is toggled
                scope.toggleAllAssets = function() {
                    var toggleStatus = scope.allAssets.selected;
                    var allAssets = getAllAssets();
                    scope.allAssets.selectCount = toggleStatus ? allAssets.length : 0;
                    angular.forEach(allAssets, function(asset){ asset.selected = toggleStatus; });
                };

                scope.$watch('allAssets.selectCount', function(){
                    var allAssets = getAllAssets();
                    var newAssetSelected = false;
                    for(var i = 0; i < allAssets.length; i++){
                        if(allAssets[i].selected && allAssets[i].isNew){
                            newAssetSelected = true;
                            break;
                        }
                    }
                    scope.newAssetSelected = newAssetSelected;
                    scope.allAssets.selected = allAssets.length && (scope.allAssets.selectCount === allAssets.length);
                });

                var getAllAssets = function(){
                    var allAssets = [];
                    if(scope.parent) {
                        if(scope.showSearchResults){
                            if(scope.searchResults.dropbox){
                                allAssets = allAssets.concat(scope.searchResults.dropbox.hits);
                            }
                            if(scope.searchResults.assignment){
                                allAssets = allAssets.concat(scope.searchResults.assignment.hits);
                            }
                            if(scope.searchResults.zoom){
                                allAssets = allAssets.concat(scope.searchResults.zoom.hits);
                            }
                        } else {
                            if (scope.parent.dropboxAssets) {
                                allAssets = allAssets.concat(scope.parent.dropboxAssets);
                            }
                            if (scope.parent.assignmentAssets) {
                                allAssets = allAssets.concat(scope.parent.assignmentAssets);
                            }
                            if (scope.parent.zoomAssets) {
                                allAssets = allAssets.concat(scope.parent.zoomAssets);
                            }
                        }
                    }
                    return allAssets;
                };

                var selectContentsIfRequired = function(){
                    var contents = getAllAssets();
                    if(scope.allAssets.selected){
                        var newAssetSelected = false;
                        angular.forEach(contents, function(content){
                            content.selected = true;
                            if(content.isNew && !newAssetSelected) {
                                newAssetSelected = true;
                            }
                        });
                        scope.newAssetSelected = newAssetSelected;
                        scope.allAssets.selectCount = contents.length;
                    } else {
                        var selected = 0;
                        angular.forEach(contents, function(content){ if(content.selected) { selected++; } });
                        scope.allAssets.selectCount = selected;
                    }
                };

                scope.createDeleteRequest = function(asset){
                    scope.assetsToDelete =  [];
                    // Bulk delete uses this
                    if(typeof asset === 'undefined') {
                        var allAssets = getAllAssets();
                        angular.forEach(allAssets, function (asset) {
                            if (asset.selected) {
                                scope.assetsToDelete.push({cid: asset.parent.cid, aid: asset.xid});
                            }
                        });
                    } else {
                        scope.assetsToDelete.push({cid: asset.parent.cid, aid: asset.xid});
                    }
                    $('#deleteModal').modal('show');
                };

                scope.deleteAssets = function() {
                    AssetService.DeleteAsset.erase(scope.assetsToDelete, function(response){
                        scope.allAssets = {selected: false, selectCount: 0};
                        CollectionService.GetNewMediaInboxSubmissions.get({cid: scope.parent.cid}, function (response) {
                            if(scope.submissions.new !== response.newSubmissions){
                                // The $watch on "submissions.new" will take care of refreshing the content list, so there's no need to do that here
                                scope.submissions.new = response.newSubmissions;
                            } else {
                                scope.getMediaInboxAssets();
                            }
                            if(scope.showSearchResults){
                                findContent();
                            }
                            $('#deleteModal').modal('hide');
                        });
                    });
                };

                scope.createPublishRequest = function(asset){
                    scope.assetsToPublish =  [];
                    // Bulk delete uses this
                    if(typeof asset === 'undefined') {
                        var allAssets = getAllAssets();
                        angular.forEach(allAssets, function (asset) {
                            if (asset.selected) {
                                scope.assetsToPublish.push(asset);
                            }
                        });
                    } else {
                        scope.assetsToPublish.push(asset);
                    }
                    $('#publishModal').modal('show');
                };

                scope.chooseDestination = function(content) {
                    scope.assetPublishDestinationCid = content.xid;
                };

                scope.publishAssets = function() {
                    if(scope.assetPublishDestinationCid) {
                        var assetIds = [];
                        angular.forEach(scope.assetsToPublish, function (asset) {
                            assetIds.push(asset.xid);
                        });
                        var copyAssets = new AssetService.CopyAsset({
                            destinationCollectionId: scope.assetPublishDestinationCid,
                            assetIds: assetIds
                        });
                        copyAssets.$save(function () {
                            scope.assetPublishDestinationCid = '';
                            angular.forEach(scope.assetsToPublish, function (asset) {
                                asset.isAssetPublishedInCourse = true;
                            });
                            $('#publishModal').modal('hide');
                        });
                    }
                };

                scope.markAsNew = function(asset){
                    scope.assetsToMarkNewRequest =  [];
                    scope.assetsToMarkNew =  [];
                    // Bulk delete uses this
                    if(typeof asset === 'undefined') {
                        var allAssets = getAllAssets();
                        angular.forEach(allAssets, function (asset) {
                            if (asset.selected && !asset.isNew) {
                                scope.assetsToMarkNewRequest.push({collectionId: asset.parent.cid, assetId: asset.xid, isViewed: "0"});
                                scope.assetsToMarkNew.push(asset);
                            }
                        });
                    } else if(!asset.isNew) {
                        scope.assetsToMarkNewRequest.push({collectionId: asset.parent.cid, assetId: asset.xid, isViewed: "0"});
                        scope.assetsToMarkNew.push(asset);
                    }
                    if(scope.assetsToMarkNewRequest.length) {
                        AssetService.UpdateMetadata.update(scope.assetsToMarkNewRequest, function () {
                            scope.submissions.new += scope.assetsToMarkNew.length;
                        });
                    }
                };

                // Make the delete media inbox asset modal accessible
                $("#deleteModal").on('shown.bs.modal', function () {
                    modalFocus('#deleteMediaInboxAssetBtn', '#cancelDeleteMediaInboxAssetBtn');
                });

                // Make the publish media inbox asset modal accessible
                $("#publishModal").on('shown.bs.modal', function () {
                    modalFocus('#searchCollectionTree', '#cancelPublishMediaInboxAssetBtn');
                });

                var modalFocus = function(first, last){
                    var firstItem = $(first),
                        lastItem = $(last);

                    /*set focus on first item*/
                    firstItem.focus();

                    /*redirect last tab to first input*/
                    lastItem.on('keydown', function (e) {
                        if ((e.which === 9 && !e.shiftKey)) {
                            e.preventDefault();
                            firstItem.focus();
                        }
                    });

                    /*redirect first shift+tab to last input*/
                    firstItem.on('keydown', function (e) {
                        if ((e.which === 9 && e.shiftKey)) {
                            e.preventDefault();
                            lastItem.focus();
                        }
                    });
                };

            }
        }

    }]);
